export default "__VITE_ASSET__z4NQ9D4M__"